<script lang="ts">
	let { showLegalLinks = true } = $props<{
		showLegalLinks?: boolean;
	}>();
</script>

<footer class="marketing-footer">
	<div class="container">
		<!-- About Section - Full Width at Top -->
		<div class="footer-about">
			<h3>About LocallyGrown.net</h3>
			<p>
				Since 2002, helping farmers markets and local food communities connect online. Our platform
				makes it easy to manage orders, coordinate deliveries, and grow your local food economy.
			</p>
		</div>

		<!-- Four Column Grid -->
		<div class="footer-grid">
			<!-- Column 1: Get Started -->
			<div class="footer-section">
				<h4>Get Started</h4>
				<ul>
					<li><a href="/markets">Browse Markets</a></li>
					<li><a href="/features">Platform Features</a></li>
					<li><a href="/pricing">Pricing</a></li>
					<li><a href="/markets/new">Start a Market</a></li>
				</ul>
			</div>

			<!-- Column 2: Learn More -->
			<div class="footer-section">
				<h4>Learn More</h4>
				<ul>
					<li><a href="/story">Our Story</a></li>
					<li><a href="/compare">Compare Platforms</a></li>
					<li><a href="/why-not-open-source">Why Not Open Source?</a></li>
					<li><a href="/faq/marketing">FAQ</a></li>
				</ul>
			</div>

			<!-- Column 3: Resources -->
			<div class="footer-section">
				<h4>Resources</h4>
				<ul>
					<li><a href="/roadmap">Product Roadmap</a></li>
					<li><a href="/docs">Support</a></li>
					<li><a href="mailto:eric@locallygrown.net">Contact</a></li>
				</ul>
			</div>

			<!-- Column 4: Legal -->
			{#if showLegalLinks}
				<div class="footer-section">
					<h4>Legal</h4>
					<ul>
						<li><a href="/legal/termsofuse">Terms of Use</a></li>
						<li><a href="/legal/privacy">Privacy Policy</a></li>
						<li><a href="/legal/dmca">DMCA</a></li>
					</ul>
				</div>
			{/if}
		</div>

		<!-- Footer Bottom -->
		<div class="footer-bottom">
			<p>&copy; {new Date().getFullYear()} LocallyGrown.net, LLC. All rights reserved.</p>
		</div>
	</div>
</footer>

<style>
	.marketing-footer {
		background: var(--marketing-gradient-primary);
		color: var(--marketing-text-white);
		padding: 3rem 0 1rem;
		margin-top: 4rem;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1.5rem;
	}

	/* About Section - Prominent at Top */
	.footer-about {
		margin-bottom: 3rem;
		padding-bottom: 2rem;
		border-bottom: 2px solid rgba(255, 255, 255, 0.2);
		text-align: center;
	}

	.footer-about h3 {
		font-size: 1.5rem;
		font-weight: 700;
		color: var(--marketing-text-white);
		margin-bottom: 1rem;
		letter-spacing: -0.02em;
	}

	.footer-about p {
		color: rgba(255, 255, 255, 0.95);
		line-height: 1.7;
		font-size: 1.05rem;
		max-width: 800px;
		margin: 0 auto;
	}

	/* Four Column Grid */
	.footer-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 2rem;
		margin-bottom: 2rem;
	}

	.footer-section h4 {
		margin-bottom: 1rem;
		color: var(--marketing-text-white);
		font-weight: 600;
		font-size: 1.1rem;
		letter-spacing: -0.01em;
	}

	.footer-section ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.footer-section li {
		margin-bottom: 0.5rem;
	}

	.footer-section a {
		color: rgba(255, 255, 255, 0.8);
		text-decoration: none;
		line-height: 1.8;
		transition: all 0.2s ease;
		display: inline-block;
	}

	.footer-section a:hover {
		color: var(--marketing-text-white);
		transform: translateX(4px);
	}

	.footer-section a:focus {
		outline: 2px solid rgba(255, 255, 255, 0.5);
		outline-offset: 2px;
		border-radius: 2px;
	}

	/* Footer Bottom */
	.footer-bottom {
		text-align: center;
		padding-top: 2rem;
		border-top: 1px solid rgba(255, 255, 255, 0.3);
		color: var(--marketing-text-white);
		font-size: 0.9rem;
	}

	.footer-bottom p {
		color: var(--marketing-text-white) !important;
		margin: 0;
	}

	/* Responsive Design */
	@media (max-width: 1024px) {
		.footer-grid {
			grid-template-columns: repeat(2, 1fr);
			gap: 2rem 1.5rem;
		}
	}

	@media (max-width: 768px) {
		.marketing-footer {
			padding: 2rem 0 1rem;
			margin-top: 2rem;
		}

		.footer-about {
			margin-bottom: 2rem;
			padding-bottom: 1.5rem;
			text-align: left;
		}

		.footer-about h3 {
			font-size: 1.3rem;
		}

		.footer-about p {
			font-size: 1rem;
		}

		.footer-grid {
			grid-template-columns: 1fr;
			gap: 1.5rem;
		}

		.footer-section {
			padding-top: 1rem;
			border-top: 1px solid rgba(255, 255, 255, 0.1);
		}

		.footer-section:first-child {
			border-top: none;
			padding-top: 0;
		}

		.footer-section a:hover {
			transform: translateX(2px);
		}
	}

	@media (max-width: 480px) {
		.container {
			padding: 0 1rem;
		}

		.footer-about h3 {
			font-size: 1.2rem;
		}

		.footer-section h4 {
			font-size: 1rem;
		}
	}
</style>
